<div>
  @if (filterColumn().isDropdown) {
    <gstar-dropdown-filter
      gstarDropDownAppkitOverlayListFix
      [filterColumn]="filterColumn()"
      (filterChanged)="filterHandler($event)" />
  } @else if (filterColumn().isCombobox) {
    <gstar-combobox-filter
      [filterColumn]="filterColumn()"
      (filterChanged)="filterHandler($event)" />
  } @else if (filterColumn().isDatepicker) {
    <gstar-datepicker-filter
      [filterColumn]="filterColumn()"
      (filterChanged)="filterHandler($event)" />
  } @else if (filterColumn().isSlider) {
    <gstar-slider-filter
      [filterColumn]="filterColumn()"
      (filterChanged)="filterHandler($event)" />
  } @else {
    <gstar-default-textfield-filter
      [filterColumn]="filterColumn()"
      (filterChanged)="filterHandler($event)" />
  }
</div>
